import {
  PLAY_AUDIO,
  PAUSE_AUDIO,
  SET_AUDIO,
  RESET_AUDIO,
  SET_PROGRESS,
  AudioPlayerActionsTypes,
} from "./AudioPlayerActions";

interface AudioPlayer {
  audio: any;
  isPlaying: boolean;
  progress: number;
}

const initialState: AudioPlayer = {
  audio: "",
  isPlaying: false,
  progress: 0,
};

const AudioPlayerReducer = (
  state = initialState,
  action: AudioPlayerActionsTypes
) => {
  switch (action.type) {
    case SET_AUDIO:
      if (
        state.audio &&
        // is audie playing (even if not properly tracked?)
        (state.isPlaying || typeof state.audio === "object")
      ) {
        if (typeof state.audio.unload === "function") {
          state.audio.unload();
        } else if (state.audio.playing()) {
          state.audio.pause();
        }
      }
      return {
        ...initialState,
        isPlaying: false,
        audio: action.payload,
      };

    case PLAY_AUDIO:
      return {
        ...state,
        isPlaying: true,
      };
    case PAUSE_AUDIO:
      return {
        ...state,
        isPlaying: false,
      };
    case SET_PROGRESS:
      return {
        ...state,
        progress: action.payload,
      };
    case RESET_AUDIO:
      return { ...state, isPlaying: false, progress: 0 };
    default:
      return state;
  }
};

export default AudioPlayerReducer;
